import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { SpotlightComponent } from './components/spotlight/spotlight.component';
import { SpotlightRoutingModule } from './spotlight-routing.module';
import { FlexLayoutModule} from '@angular/flex-layout';
import { SpotlightRootComponent } from './components/spotlight-root/spotlight-root.component';
import { RedCarpetModule } from './red-carpet/red-carpet.module';
import { GroupSharingModule } from '../group-sharing/group-sharing.module';
import { TheaterModule } from '../theater/theater.module';

@NgModule({
  declarations: [
    SpotlightComponent,
    SpotlightRootComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SpotlightRoutingModule,
    FlexLayoutModule,
    RedCarpetModule,
    GroupSharingModule,
    TheaterModule
  ]
})
export class SpotlightModule { }
